import {
  CHANGE_MOBILE_SIDEBAR_VISIBILITY,
  CHANGE_SIDEBAR_VISIBILITY,
  CLOSE_SIDEBAR,
  OPEN_SIDEBAR

} from '../actions/sidebarActions';


const initialState = {
  show: false,
  collapse: false

} // END initialState


export default function (state = initialState, action) {
  switch (action.type) {
    case CLOSE_SIDEBAR:
      return { ...state, collapse: true };

    case OPEN_SIDEBAR:
      return { ...state, collapse: false };

    case CHANGE_SIDEBAR_VISIBILITY:
      return { ...state, collapse: !state.collapse };

    case CHANGE_MOBILE_SIDEBAR_VISIBILITY:
      return { ...state, show: !state.show };

    default:
      return state;

  }

} // END reducer


// WEBPACK FOOTER //
// ./src/redux/reducers/sidebarReducer.js